import { makeStyles } from '@mui/styles';
import { TicketStatusColors, TicketStatusGroup } from '../../utils/resolveTicketStatusGroup';
import { Theme } from '@mui/material/styles';
import { lighten } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  chipStatus: {
    padding: '4px 12px',
    borderRadius: '12px',
    color: theme.palette.common.white,
    fontSize: 'small',
    display: 'inline-block',
    fontWeight: 500,
    width: 'fit-content',
  },
  [TicketStatusGroup.New]: {
    backgroundColor: `${TicketStatusColors[TicketStatusGroup.New]}1A`,
    border: `1px solid ${TicketStatusColors[TicketStatusGroup.New]}`,
    color: theme.palette.mode === 'dark'
      ? lighten(TicketStatusColors[TicketStatusGroup.New], 0.5)
      : TicketStatusColors[TicketStatusGroup.New]
},
  [TicketStatusGroup.InProgress]: {
    backgroundColor: `${TicketStatusColors[TicketStatusGroup.InProgress]}1A`,
    border: `1px solid ${TicketStatusColors[TicketStatusGroup.InProgress]}`,
    color: theme.palette.mode === 'dark'
      ? lighten(TicketStatusColors[TicketStatusGroup.InProgress], 0.5)
      : TicketStatusColors[TicketStatusGroup.InProgress]
  },

  [TicketStatusGroup.Completed]: {
    backgroundColor: `${TicketStatusColors[TicketStatusGroup.Completed]}1A`,
    border: `1px solid ${TicketStatusColors[TicketStatusGroup.Completed]}`,
    color: theme.palette.mode === 'dark'
      ? lighten(TicketStatusColors[TicketStatusGroup.Completed], 0.5)
      : TicketStatusColors[TicketStatusGroup.Completed]
  },
}));

export default useStyles;
